import React from 'react';
import ArrayToTable from '../arrayToTable/ArrayToTable';
import { FormatText } from '../../lib/FormatText';
import './AttributeValue.css';

interface AttributeValueProps {
    itemKey: string;
    value: string | number;
    small?: boolean;
}

const AttributeValue: React.FC<AttributeValueProps> = ({ itemKey, value, small }) => {

    
    const sepFields = ['（円）'];

    /* ******************
    * string型の配列を配列に変換
    * ******************/
    const parseTextArray = (parseValue: string) => {
        if (typeof parseValue === 'string' && parseValue.startsWith('[') && parseValue.endsWith(']')) {
            try {
            return JSON.parse(parseValue);
            } catch (e) {
            console.error('Failed to parse JSON:', e);
            }
        }
        return parseValue;
    };


    const parseValue = parseTextArray(value as string);
    const isTwoDimensionalArray = Array.isArray(value) && Array.isArray(parseValue[0]);

    return isTwoDimensionalArray ?
        // 2次元配列が来たら、テーブル表示にする
        <ArrayToTable data={parseValue} small={small} />
        : (
        Array.isArray(parseValue) ?
            parseValue.map((item, idx) => (
                <p><FormatText key={idx} text={item} /></p>
            ))
            :
            <p>
                <FormatText 
                    text={parseValue} 
                    showThousandSeparator={sepFields.filter((val) => itemKey.includes(val)).length > 0} 
                />
            </p>
        )

};

export default AttributeValue;
